import { useHookstate } from "@hookstate/core";
import { GET_RELEASE_QUERY_KEY } from "../api/readerScreenApi";
import { useParams } from "react-router";
import { rootComponentsStore } from "../../../hookstate/rootComponentsStore";

export function useReleaseDataQueryKey() {
  const { uuid } = useParams();

  return [...GET_RELEASE_QUERY_KEY, uuid];
}

export function useReleaseInfoDataQueryKey() {
  const uuid = useHookstate(rootComponentsStore.slideInMenuConfig).get({
    noproxy: true,
  })?.releaseUuid;

  return ["releaseDetailsRelease", uuid];
}
